//封装vue-resource请求方法
import Vue from 'vue';
import axios from 'axios';

var VueEvent = new Vue();
import { Loading } from 'element-ui';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// var serviceUrl = sessionStorage.getItem('REQURL',serviceUrl);

var serviceUrl =process.env.NODE_ENV === "development" ? `${location.protocol}//${process.env.serviceUrl}`  : location.protocol + "//"+window.location.host

sessionStorage.setItem("REQURL",serviceUrl);
//从static中读取config.json配置文件。弃用env配置中的serviceUrl字段
//方便打包后修改请求地址，以适应多种环境


Vue.use(ElementUI);
const callerid = process.env.callerid;
const license = process.env.license;

function conversionJsonBC(requestParams) {
    //var serviceCode = searchBusscode(requestParams.action);
    var jsonC = {
        "message": {
            "header": {
                "auth": {
                    "callerid": callerid,
                    "license": license,
                    "token": sessionStorage.getItem("tokens"),
                    "ipaddr": null,
                    "macaddr": null
                },
                "servicecode": { "systemcode": "", "busscode": "", "version": 1, "apiurl": null }
            },
            "body": {
                "dataset": [],
                "query": { "pageno": 1, "pagesize": 10, "sortfiled": null, "sorttype": null, "condition": [] }
            },
            "extend": null
        }
    };
    if (requestParams.hasOwnProperty("query")) {
        var Pquery = requestParams.query;
        if (Pquery.hasOwnProperty("pageno")) {
            jsonC.message.body.query.pageno = requestParams.query.pageno;
        }
        if (Pquery.hasOwnProperty("pagesize")) {
            jsonC.message.body.query.pagesize = requestParams.query.pagesize;
        }
        if (Pquery.hasOwnProperty("sortfiled")) {
            jsonC.message.body.query.sortfiled = requestParams.query.sortfiled;
        }
        if (Pquery.hasOwnProperty("sorttype")) {
            jsonC.message.body.query.sorttype = requestParams.query.sorttype;
        }
    }
    if (requestParams.hasOwnProperty("condition")) {
        jsonC.message.body.query.condition = requestParams.condition;
    }
    if (requestParams.hasOwnProperty("datas")) {
        jsonC.message.body.dataset = requestParams.datas;
    }
    //console.log(JSON.stringify(jsonC))
    return jsonC;
}

function conversionJsonCB(data) {
    //console.log(JSON.stringify(data))
    var jsonB = {
        "apiurl": null,
        "datas": [],
        "datacompress": null,
        "dataencrypt": null,
        "response": { "code": null, "text": null },
        "bussresponse": { "code": null, "text": null },
        "query": { "pageno": 1, "pagesize": 10, "pagecount": 0, "recordcount": 0, "sortfiled": null, "sorttype": null },
        "condition": []
    };
    //if (data.hasOwnProperty("dataset")) {
    jsonB.datas = data.message.body.dataset;
    //}
    var dbody = data.message.body;
  if (dbody.hasOwnProperty("response")) {
      jsonB.response.code = data.message.body.bussresponse.code;
      jsonB.response.text = data.message.body.bussresponse.text;
    }
    if (dbody.hasOwnProperty("bussresponse")) {
        jsonB.bussresponse.code = data.message.body.bussresponse.code;
        jsonB.bussresponse.text = data.message.body.bussresponse.text;
    }
    if (data.hasOwnProperty("datacompress")) {
        jsonB.datacompress = data.message.body.datacompress;
    }
    if (data.hasOwnProperty("dataencrypt")) {
        jsonB.dataencrypt = data.message.body.dataencrypt;
    }
    if (dbody.hasOwnProperty("queryresponse") && data.message.body.queryresponse != null) {
        var pqueryresponse = data.message.body.queryresponse;
        if (pqueryresponse.hasOwnProperty("pageno")) {
            jsonB.query.pageno = data.message.body.queryresponse.pageno;
        }
        if (pqueryresponse.hasOwnProperty("pagesize")) {
            jsonB.query.pagesize = data.message.body.queryresponse.pagesize;
        }
        if (pqueryresponse.hasOwnProperty("pagecount")) {
            jsonB.query.pagecount = data.message.body.queryresponse.pagecount;
        }
        if (pqueryresponse.hasOwnProperty("recordcount")) {
            jsonB.query.recordcount = data.message.body.queryresponse.recordcount;
        }
        if (pqueryresponse.hasOwnProperty("sortfiled")) {
            jsonB.query.sortfiled = data.message.body.queryresponse.sortfiled;
        }
        if (pqueryresponse.hasOwnProperty("sorttype")) {
            jsonB.query.sorttype = data.message.body.queryresponse.sorttype;
        }
    }
    return jsonB;
}


var vueajax = {
  addMapKey(jmzJSON, node, key, value) {
    jmzJSON[node][key.toUpperCase()] = $.trim(value) ? $.trim(value) : null;
  },
  addRowData(jmzJSON, node, value) {
    jmzJSON[node].push(value);
  },
  post(requestParams, processResult, isprompt, nouseTip, async, errorFlag, targetEl) { //requestParams:请求数据；processResult:回调函数，不写则不执行回调函数；isprompt请求成功时是否提示；nouseTip:是否显示加载层，默认显示；async:同步和异步，true是同步，false或者不写是异步；errorFlag：是否在服务端返回错误时执行回调方法，不写或者为false则不执行，true执行；targetEl为加载层显示的范围，需要时传入对应范围的class/id/dom，不传默认全屏

    let tokens = sessionStorage.getItem("tokens");
    if (tokens == null || tokens == undefined || tokens == "") {
      VueEvent.$alert("登录已过期，请重新登录", "提示", {
        dangerouslyUseHTMLString: true,
        callback: function () {
          window.location.href = '/'
        }
      });
    }
    var nouseTip = nouseTip;
    //console.log(abc)
    if (!nouseTip) {
      if (targetEl != undefined) {
        var loading = VueEvent.$loading({
          lock: true,
          text: "数据加载中，请稍后...", // '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.45)',
          target: document.querySelector(targetEl)
        });
        //let target = document.querySelector(abc)
        //  loading.service({ fullscreen: target ? false : true, target })
      }
      else {
        var loading = VueEvent.$loading({
          lock: true,
          text: "数据加载中，请稍后...", // '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.45)'
        });
      }
    }

    var requestAPI = requestParams.action;
    requestParams = conversionJsonBC(requestParams);
    console.log(requestAPI)
    $.ajax({
      //url: BASE_URL + "/jmz/his/" + requestParams.message.servicecode.systemcode + "/" + jsonC.message.servicecode.busscode,//url路径
      url: `${serviceUrl}${requestAPI}`,
      type: 'POST', //GET
      // timeout: 60000,
      async: !async, //或false,是否异步
      data: JSON.stringify(requestParams) || {},
      crossDomain: true,
      cache: false,
      //xhrFields: {
      //  withCredentials: true
      //},
      //crossDomain: true,
      timeout: 60000, //超时时间
      dataType: 'json', //返回的数据格式：
      beforeSend: function (XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader("Authorization", "Bearer " + tokens)
        XMLHttpRequest.setRequestHeader("Content-Type", "application/json; charset=utf-8")
      },
      success: function (data) {
        if (data.message.body.bussresponse.code == 1) {
          switch (data.message.header.response.code) {
            case 1:
              if (!isprompt) {
                VueEvent.$message({
                  message: data.message.body.bussresponse.text,
                  type: 'success',
                  duration: '3000',
                  showClose: true,
                });
              }
              processResult(conversionJsonCB(data));
              break;
            case 0:
              VueEvent.$message({
                message: data.message.header.response.text,
                type: 'error',
                duration: '3000',
                showClose: true,
              });
              if(data.message.header.response.text == 'token已失效'){
                window.location.href = '/'
              }
              if (!isprompt) {


              }
              if (errorFlag) {
                processResult(conversionJsonCB(data));
              }
              break;
            default:
              if (!isprompt) {
                VueEvent.$message({
                  message: data.message.body.bussresponse.text,
                  type: 'success',
                  duration: '3000',
                  showClose: true,
                });
              }
              processResult(conversionJsonCB(data));
              break;
          }
          if (!nouseTip) {
            loading.close();
          }
        } else {
          if (!nouseTip) {
            loading.close();
          }

          VueEvent.$message({
            message: data.message.body.bussresponse.text,
            type: 'error',
            duration: '0',
            showClose: true,
          });
          //VueEvent.$alert(data.message.header.response.text, i18n.t('message.tip.prompt'), {
          //    dangerouslyUseHTMLString: true
          //});
          if (errorFlag) {
            processResult(conversionJsonCB(data));
          }
        }
      },
      error: function (data) {
        if(data.responseJSON.error == 'invalid_token'){
          window.location.href = '/'
        }
        if (!nouseTip) {
          loading.close();
        }
        VueEvent.$message({
          message: "请求失败，请联系管理员",
          type: 'error',
          duration: '0',
          showClose: true,
        });
        //VueEvent.$alert(i18n.t('message.tip.prompterror'), i18n.t('message.tip.prompt'), {
        //  dangerouslyUseHTMLString: true
        //});
      },
      complete: function (processResult) { }
    })
  },
  postFile(requestParams, xfileName, isprompt, nouseTip, async, errorFlag, targetEl) { //requestParams:请求数据；processResult:回调函数，不写则不执行回调函数；isprompt请求成功时是否提示；nouseTip:是否显示加载层，默认显示；async:同步和异步，true是同步，false或者不写是异步；errorFlag：是否在服务端返回错误时执行回调方法，不写或者为false则不执行，true执行；targetEl为加载层显示的范围，需要时传入对应范围的class/id/dom，不传默认全屏
    var xurl = ''
    if(requestParams.action.indexOf('¥') != -1){
      requestParams.action = requestParams.action.split("¥")[1];
      xurl = outsideUrl;
    }else{
      xurl = insideUrl;
    }

    let tokens = sessionStorage.getItem("tokens");
    if (tokens == null || tokens == undefined || tokens == "") {
      VueEvent.$alert("登录已过期，请重新登录", "提示", {
        dangerouslyUseHTMLString: true,
        callback: function () {
          window.location.href = '/'
        }
      });
    }
    var nouseTip = nouseTip;
    //console.log(abc)
    if (!nouseTip) {
      if (targetEl != undefined) {
        var loading = VueEvent.$loading({
          lock: true,
          text: "数据加载中，请稍后...", // '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.45)',
          target: document.querySelector(targetEl)
        });
        //let target = document.querySelector(abc)
        //  loading.service({ fullscreen: target ? false : true, target })
      }
      else {
        var loading = VueEvent.$loading({
          lock: true,
          text: "数据加载中，请稍后...", // '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.45)'
        });
      }
    }

    var requestAPI = requestParams.action;
    requestParams = conversionJsonBC(requestParams);
    axios({ // 用axios发送post请求
      method: 'POST',
      url: `${location.protocol}//${xurl}${requestAPI}`, // 请求地址
      data: JSON.stringify(requestParams) || {}, // 参数
      responseType: 'blob', // 表明返回服务器返回的数据类型
      headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': "Bearer " + tokens,
      }
    }).then(function (response) {
      if (!nouseTip) {
               loading.close();
      }
      console.log(response)
      const blob = new Blob([response.data]);
      const fileName = xfileName + '.xlsx';
      const elink = document.createElement('a');
      elink.download = fileName;
      elink.style.display = 'none';
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    })
    .catch(function (error) {
      console.log(error);
    });
  },
  postDirectly(requestParams, processResult) { //requestParams:请求数据
    //console.log(BASE_URL + "/api-system/api" + requestParams.action)
    $.ajax({
      //url: BASE_URL + "/jmz/his/" + requestParams.message.servicecode.systemcode + "/" + jsonC.message.servicecode.busscode,//url路径
      url: `${serviceUrl}${requestParams.action}`,
      type: 'POST', //GET
      async: false, //或false,是否异步
      data: JSON.stringify(requestParams) || {},
      contentType: "application/json; charset=utf-8",
      crossDomain: true,
      cache: false,
      timeout: 5000, //超时时间
      dataType: 'json', //返回的数据格式：
      beforeSend: function (XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader("Content-Type", "application/json; charset=utf-8")
      },
      success: function (data) {
        processResult(data);
      },
      error: function (data) {
        VueEvent.$alert("请求失败，请联系管理员", "提示", {
          dangerouslyUseHTMLString: true
        });
      },
      complete: function (processResult) { }
    })
  }
}

export default vueajax;



// WEBPACK FOOTER //
// ./src/model/ajax.js